import { SharedErrors } from 'web_core_library';

export enum EMigrationFlag {
  MIGRATION_NOT_STARTED = 0,
  MIGRATION_STARTED = 1,
  MIGRATION_FINISHED_BY_BACKEND = 2,
  MIGRATION_CONFIRMED_BY_APP = 3,
}

export class MigrationError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, MigrationError.prototype);
    this.feature = 'Migration';
    this.errorType = SharedErrors.ALERT_TYPE;
  }
}
